define('views/app/member/setting/setting-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // views
    'views/parts/panel/base-panel',
    'views/app/member/setting/personal/personal-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // views
    VBasePanel,
    VMemberPersonalContent
) {

    var VMemberSettingPanel = VBasePanel.extend({
        header: {
            title: "Settings",
            subtitle: "Customize your own Totalcoaching",
        },
        tabs: [{ id: 'personal', title: 'Personal', icon: 'sl-icon-user', active: true }],
        content: {
            personal: VMemberPersonalContent,
        },
        defaultView: 'personal',

        initialize: function(opt) {
            opt = opt || {};
            this.group = opt.group;
            this.url = opt.url;

            this.getView('personal', {
                model: User,
                url: this.url,
                group: this.group
            });
        },

    });

    return VMemberSettingPanel;
});

